import PropTypes from 'prop-types';
import React, { Fragment, Component } from 'react';
import moment from 'moment';
import async from 'async';
//import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Transition from '../dialogs/Transition';
import FormSelect from '../form/FormSelect';
import SwipeableViews from 'react-swipeable-views';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Zoom from '@material-ui/core/Zoom';

import _ from 'lodash';
//import FormText from "../form/FormText";
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
//import {Link} from "react-router-dom";
import ShiftSelect from '../advancedForm/ShiftSelect';
import FormTimePicker from '../form/FormTimePicker';
import { post } from '../../modules/utility';
import FormTextArea from '../form/FormTextArea';
import Note from '../Note';
import Badge from '@material-ui/core/Badge';
import SectionHeader from '../SectionHeader';

import { statuses } from './WorkDayStatuses';
import FormCheckbox from '../form/FormCheckbox';

//- graphics
import CircularProgress from '@material-ui/core/CircularProgress';
import GreenChecked from '../../images/icons/greenChecked.svg';
import AuthUserContainer from '../../containers/AuthUser';
import FormDatePicker from '../form/FormDatePicker';
//import TicketContainer from "../../containers/Ticket/Ticket";
const SAFETY_DEPT_ID = 9;
const HR_DEPT_ID = 4;

const isWorkingStatusMap = {};
const statusMap = {};
const statusOptionMap = {};
const showMultiDaySelectMap = {};
const workingAtLocationStatuses = [];

statuses.forEach(({ display, value, isWorking, showMultiDaySelect, isAtLocation }) => {
	statusMap[value] = display;
	statusOptionMap[value] = { value, display };
	if (isWorking) {
		isWorkingStatusMap[value] = true;
	}
	if (showMultiDaySelect) {
		showMultiDaySelectMap[value] = true;
	}
	if (isAtLocation) {
		workingAtLocationStatuses.push(value);
	}
});

function TabPanel(props) {
	const { children } = props;

	return (
		<div style={{ paddingTop: 20, paddingLeft: 10, paddingRight: 10 }}>
			<Box>{children}</Box>
		</div>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
};

function styles() {
	return {
		inner: {
			padding: '40px 30px',
		},
		dialogTitleContainer: {
			borderBottom: '1px solid #eee',
			paddingBottom: 5,
			marginBottom: 10,
		},
		dialogTitle: {
			fontSize: 30,
			fontWeight: 300,
			display: 'flex',
			justifyContent: 'space-between',
		},
		usualShiftTime: {
			fontSize: 15,
			fontWeight: 400,
			color: '#555',
			margin: '0px 3px',
		},
		noNotes: {
			color: '#999',
			textTransform: 'italic',
		},
		dateNote: {
			color: '#666',
			fontSize: 14,
		},
		noteContainer: {
			paddingBottom: 5,
			borderBottom: '1px solid #f5f5f5',
			marginBottom: 5,
		},
		badgeMargin: {
			paddingRight: 10,
		},
		noteBadge: {
			backgroundColor: '#00BCD4',
		},
		activityBadge: {
			backgroundColor: '#9C27B0',
		},
		dialogRoot: {
			//overflow: 'visible'
			// alignItems: 'end',
		},
		closeButton: {
			position: 'absolute',
			right: 15,
			top: 15,
			color: '#555',
		},
		addButton: {
			//verticalAlign : 'middle',
			//textDecoration: 'none',
			//marginBottom: 0,
			//borderRadius: 100,
			padding: '10px 35px',
			fontSize: 16,
			marginTop: 20,
		},
		greenCheckedIcon: {
			display: 'inline-block',
			width: 33,
			height: 33,
			backgroundImage: `url('${GreenChecked}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: 2,
			marginLeft: 5,
		},
		isSaving: {
			marginLeft: 20,
			fontSize: 16,
			color: '#1565C0',
		},
		savingSuccessful: {
			marginLeft: 20,
			fontSize: 16,
			color: '#2E7D32',
		},
	};
}

class UpdateWorkDayDialog extends Component {
	constructor(props) {
		super(props);
		this.state = {
			formFieldError: {},
			selectedTabValue: 0,
			isSaving: false,
			savingSuccessful: false,

			isSavingNote: false,
			savingNoteSuccessful: false,
		};
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		const { workDay } = this.props;
		const { isLate, shiftTime, lateExpectedArrivalTime } = this.state;

		if (isLate !== prevState.isLate && isLate && !lateExpectedArrivalTime) {
			let newLateExpectedArrivalTime;
			if (shiftTime) {
				newLateExpectedArrivalTime = shiftTime;
			} else {
				newLateExpectedArrivalTime = moment().format('YYYY-MM-DD HH:mm');
			}

			this.setState({
				lateExpectedArrivalTime: newLateExpectedArrivalTime,
			});
		}

		if (workDay !== prevProps.workDay) {
			if (!workDay) {
				return;
			}
			const { shiftId, status, isLate, requirePtoRequest, date } = workDay;

			let shiftTime = workDay.shiftTime;
			let lateExpectedArrivalTime = workDay.lateExpectedArrivalTime;
			if (lateExpectedArrivalTime) {
				lateExpectedArrivalTime = moment(`2019-01-01 ${lateExpectedArrivalTime}`).format(
					'YYYY-MM-DD HH:mm'
				);
			}

			if (shiftTime) {
				shiftTime = moment(`2019-01-01 ${shiftTime}`).format('YYYY-MM-DD HH:mm');
			}

			this.setState({
				shiftId,
				shiftTime,
				status,
				isLate,
				lateExpectedArrivalTime,
				requirePtoRequest,
				openNoCallNoShowTicket: false,
				showMultiDaySelection: false,
				openLateTicket: false,
				endDateForStatus: date,
			});
		}
	}

	getInputProps = (path, defaultValue) => {
		return {
			key: path,
			path,
			value: this.getValue(path, defaultValue),
			checked: this.getValue(path, defaultValue),
			error: this.getError(path),
			onChange: this.onChange,
			gridProps: { md: 12 },
		};
	};

	getValue = (path, defaultValue) => {
		const _d = _.isUndefined(defaultValue) ? '' : defaultValue;
		const value = _.get(this.state, path, _d);
		if (_.isNull(value)) {
			return _d;
		} else {
			return value;
		}
	};

	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	onChange = (value, path, error) => {
		const arrayPath = _.toPath(path);
		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			if (arrayPath.length > 1) {
				base = _.cloneDeep(base);
				_.set(base, arrayPath.slice(1), value);
				newState[basePath] = base;
			} else {
				newState[basePath] = value;
			}
		} else {
			newState[basePath] = value;
		}

		//- Clear any errors on the path
		let formFieldError = Object.assign({}, this.state.formFieldError);

		if (error) {
			formFieldError[path] = error;
		} else {
			delete formFieldError[path];
		}
		newState.formFieldError = formFieldError;

		//- Lets try to default the shift time
		const { assignedShiftTime } = this.props;
		if (path === 'status' && isWorkingStatusMap[value] && !this.state.shiftTime) {
			if (assignedShiftTime) {
				newState.shiftTime = moment(`2019-01-01 ${assignedShiftTime}`).format('YYYY-MM-DD HH:mm');
			}
		}

		if (path === 'status') {
			newState.openNoCallNoShowTicket = false;
			newState.openLateTicket = false;
			newState.endDateForStatus = false;
			newState.showMultiDaySelection = false;
		}

		this.setState(newState);
	};

	submitShiftChange = () => {
		const { workDay, showErrors, onRefreshData } = this.props;
		const { date, userId, userAssignmentTypeId } = workDay;

		const {
			status,
			shiftId,
			shiftTime,
			//isLate,
			lateExpectedArrivalTime,
			formFieldError,
			requirePtoRequest,
			endDateForStatus,
			showMultiDaySelection,
		} = this.state;

		let isLate = !!this.state.isLate;

		const requiredFields = [{ path: 'status', label: 'Status' }];

		if (isWorkingStatusMap[status]) {
			requiredFields.push(
				{ path: 'shiftTime', label: 'Shift time' },
				{ path: 'shiftId', label: 'Shift (Day or Night)' }
			);
		}

		requiredFields.forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		const params = {
			userId,
			eventDate: date,
			status,
			requirePtoRequest,
		};
		if (showMultiDaySelection && endDateForStatus) {
			params.endDateForStatus = endDateForStatus;
			params.userAssignmentTypeId = userAssignmentTypeId; // for multi day
		}

		if (isWorkingStatusMap[status]) {
			params.shiftId = shiftId;
			params.isLate = isLate;

			if (shiftTime) {
				params.shiftTime = moment(shiftTime).format('HH:mm');
			}

			if (isLate && lateExpectedArrivalTime) {
				params.lateExpectedArrivalTime = moment(lateExpectedArrivalTime).format('HH:mm');
			}
		}

		this.setState({ isSaving: true, savingSuccessful: false });

		async.waterfall(
			[
				(callback) => {
					post({
						method: 'workDayOverride.add',
						params,
						callback,
					});
				},
				(r, callback) => {
					const { openNoCallNoShowTicket, openLateTicket } = this.state;
					if (!openNoCallNoShowTicket && !openLateTicket) {
						return callback(null, null);
					}

					const params = {
						workDay,
					};

					if (openNoCallNoShowTicket) {
						params.ticketType = 'noCallNoShow';
					} else if (openLateTicket) {
						params.ticketType = 'late';
					}

					post({
						method: 'ticket.addTicketFromWorkDay',
						params,
						callback,
					});
				},
			],
			(err) => {
				if (err) {
					this.setState({ isSaving: false });
					showErrors(err);
					return;
				}

				_.delay(() => {
					this.setState({
						isSaving: false,
						savingSuccessful: true,
					});

					onRefreshData();

					_.delay(() => {
						this.setState({ savingSuccessful: false });
					}, 2000);
				}, 100);
			}
		);
	};

	submitAddNote = () => {
		const { workDay, showErrors, onRefreshData } = this.props;
		const { date, userId } = workDay;
		this.setState({ isSavingNote: true, savingNoteSuccessful: false });

		const { note } = this.state;

		post({
			method: 'workDayNote.add',
			params: {
				userId,
				eventDate: date,
				note,
			},
			callback: (err, r) => {
				if (err) {
					this.setState({ isSavingNote: false });
					showErrors(err);
					return;
				}

				_.delay(() => {
					const workDayNote = _.get(r, 'collections.workDayNoteCollection.0', {});
					if (!workDay.notes) {
						workDay.notes = [];
					}
					workDay.notes.push(workDayNote);

					this.setState({
						note: '',
						isSavingNote: false,
						savingNoteSuccessful: true,
					});

					onRefreshData();

					_.delay(() => {
						this.setState({ savingNoteSuccessful: false });
					}, 2000);
				}, 400);
			},
		});
	};

	handleTabChange = (event, selectedTabValue) => {
		this.setState({ selectedTabValue });
	};

	handleChangeIndex = (index) => {
		this.setState({ index });
	};

	render() {
		const { open, onClose, workDay, classes, userMap, assignedShiftTime } = this.props;

		const { selectedTabValue } = this.state;

		if (!workDay) {
			return (
				<Dialog open={open} TransitionComponent={Transition} onClose={onClose}>
					<div className={classes.inner}>Sorry missing workday info. Please refresh???</div>
				</Dialog>
			);
		}

		const {
			date,
			userId,
			notes = [],
			overrides = [],
			//workDayOverrides,
			//shiftId,
			//shiftTime,
			//overrides,
		} = workDay;

		const dateFormatted = moment(date).format('MMM Do');
		const user = userMap[userId] || { firstName: 'Missing', lastName: '' };
		const userFullName = `${user.firstName} ${user.lastName}`;

		let assignedShiftTimeDisplay = '';
		if (assignedShiftTime) {
			assignedShiftTimeDisplay = moment(assignedShiftTime, 'HH:mm:ss').format('h:mm a');
		}

		return (
			<Dialog
				open={open}
				onClose={onClose}
				fullWidth={true}
				maxWidth={'md'}
				classes={{ scrollPaper: classes.dialogRoot }}
			>
				<div className={classes.inner}>
					<div className={classes.dialogTitleContainer}>
						<div className={classes.dialogTitle}>
							<div style={{ display: 'flex', flexDirection: 'row' }}>
								<div>{dateFormatted} - </div>
								<div style={{ marginLeft: 5 }}>
									<div>
										<strong>{userFullName}</strong>
									</div>
									<div className={classes.usualShiftTime}>
										Usual shift time : {assignedShiftTimeDisplay}
									</div>
								</div>
							</div>
							<div>
								<IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
									<CloseIcon />
								</IconButton>
							</div>
						</div>
					</div>
					<Tabs
						value={selectedTabValue}
						indicatorColor="primary"
						textColor="primary"
						onChange={this.handleTabChange}
						style={{ borderBottom: '1px solid #eee' }}
					>
						<Tab label="Shift" />
						<Tab
							label={
								<Badge
									badgeContent={notes.length}
									className={classes.badgeMargin}
									color="primary"
									classes={{ colorPrimary: classes.noteBadge }}
								>
									Notes
								</Badge>
							}
						/>
						<Tab
							label={
								<Badge
									badgeContent={overrides.length}
									className={classes.badgeMargin}
									color="primary"
									classes={{ colorPrimary: classes.activityBadge }}
								>
									Activity
								</Badge>
							}
						/>
					</Tabs>

					<SwipeableViews
						//axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
						index={selectedTabValue}
						onChangeIndex={this.handleChangeIndex}
					>
						<TabPanel value={selectedTabValue} index={0}>
							{this.renderChangeShiftInfo()}
						</TabPanel>
						<TabPanel value={selectedTabValue} index={1}>
							{this.renderNotes()}
						</TabPanel>
						<TabPanel value={selectedTabValue} index={2}>
							{this.renderActivity()}
						</TabPanel>
					</SwipeableViews>
				</div>
			</Dialog>
		);
	}

	renderChangeShiftInfo = () => {
		const { classes, workDay, assignedLocationId } = this.props;
		const { isSaving, savingSuccessful } = this.state;

		return (
			<form>
				<Grid container spacing={2} style={{ marginTop: 0, marginBottom: 0 }}>
					{workDay.locationId !== assignedLocationId && this.renderDriverReassigned()}

					{this.renderStatusOptions()}

					{this.renderShiftStatusFields()}
					{this.renderMultiDayFields()}

					<Grid item md={12} style={{ display: 'flex', alignItems: 'baseline' }}>
						<Button
							variant="contained"
							color="primary"
							className={classes.addButton}
							onClick={this.submitShiftChange}
							disabled={isSaving}
						>
							Save Changes
						</Button>

						<Zoom
							in={isSaving}
							style={{ transitionDelay: isSaving ? '0ms' : '0ms' }}
							mountOnEnter
							unmountOnExit
						>
							<div className={classes.isSaving}>
								<CircularProgress style={{ verticalAlign: 'middle' }} />
								<span style={{ paddingLeft: 10 }}>Saving...</span>
							</div>
						</Zoom>

						<Zoom
							in={savingSuccessful}
							style={{ transitionDelay: savingSuccessful ? '250ms' : '0ms' }}
						>
							<div className={classes.savingSuccessful}>
								<div className={classes.greenCheckedIcon} />
								<span style={{ paddingLeft: 10 }}>Save Successful.</span>
							</div>
						</Zoom>
					</Grid>
				</Grid>
			</form>
		);
	};

	renderStatusOptions = () => {
		const { authUser, workDay } = this.props;

		const currentStatus = workDay.status;

		const statuses = [];
		// if its your day off you can only get an extra day
		if (currentStatus === 'dayOff' || currentStatus === 'swapOff') {
			statuses.push('dayOff', 'extraDay', 'swapOn', 'swapOff', 'modifiedDay');
		} else if (
			currentStatus === 'extraDay' ||
			currentStatus === 'swapOn' ||
			currentStatus === 'modifiedDay'
		) {
			// Working an extra day. Then you can miss work
			statuses.push(
				'extraDay',
				'modifiedDay',
				'swapOn',
				'swapOff',
				'cancelledEd',
				'callOut',
				'noCallNoShow',
				'absent'
			);
			statuses.push(...workingAtLocationStatuses);
		} else if (currentStatus === 'cancelledEd') {
			statuses.push('cancelledEd', 'extraDay', 'modifiedDay', 'swapOn', 'swapOff', 'dayOff');
		} else {
			statuses.push('absent', 'working', 'pto', 'callOut', 'swapOff', 'noCallNoShow');
			const { companyDepartmentIds } = authUser;
			if (
				_.includes(companyDepartmentIds, SAFETY_DEPT_ID) ||
				_.includes(companyDepartmentIds, HR_DEPT_ID)
			) {
				statuses.push('fmla', 'wc', 'loa');
			}
			statuses.push(...workingAtLocationStatuses);
		}

		const options = [];
		statuses.forEach((status) => {
			options.push(statusOptionMap[status]);
		});

		return <FormSelect {...this.getInputProps('status')} label={'Status'} options={options} />;
	};

	renderDriverReassigned = () => {
		const { workDay, locationMap, assignedLocationId } = this.props;
		const { locationId } = workDay;

		const newLocation = locationMap[locationId] || { display: 'Missing' };
		const assignedLocation = locationMap[assignedLocationId] || {
			display: 'Missing',
		};
		return (
			<Note
				label={
					`To start this time period driver is assigned to ${assignedLocation.display} ` +
					` but later on is reassigned to ${newLocation.display}`
				}
			/>
		);
	};

	renderShiftStatusFields = () => {
		const { status, isLate } = this.state;

		if (!status) {
			return <div>Pick a status to see the fields</div>;
		}

		if (isWorkingStatusMap[status]) {
			return (
				<Fragment>
					<ShiftSelect {...this.getInputProps('shiftId')} label={'Shift'} gridProps={{ sm: 6 }} />

					<FormTimePicker
						{...this.getInputProps('shiftTime')}
						label={'Shift time'}
						minutesStep={5}
						gridProps={{ sm: 6 }}
					/>

					<FormCheckbox
						{...this.getInputProps('isLate', false)}
						label={'Late arrival'}
						gridProps={{ sm: 3 }}
						showLargeFont={true}
					/>

					{isLate && (
						<Grid item sm={12}>
							<Grid container spacing={2}>
								<FormTimePicker
									{...this.getInputProps('lateExpectedArrivalTime')}
									label={'Expected arrival time'}
									gridProps={{ sm: 4 }}
								/>
								<FormCheckbox
									{...this.getInputProps('openLateTicket', false)}
									label={'Open a "Late" ticket for this driver'}
									gridProps={{ sm: 8 }}
								/>
							</Grid>
						</Grid>
					)}
				</Fragment>
			);
		} else if (status === 'pto') {
			return (
				<Fragment>
					<FormCheckbox
						{...this.getInputProps('requirePtoRequest', false)}
						label={'Require employee to fill out a PTO Request for this date'}
						showLargeFont={true}
					/>
				</Fragment>
			);
		} else if (status === 'absent') {
			return (
				<Fragment>
					<FormCheckbox
						{...this.getInputProps('openNoCallNoShowTicket', false)}
						label={'Open a "No Call No Show" ticket for this driver'}
						showLargeFont={true}
					/>
				</Fragment>
			);
		} else {
			return null;
		}
	};

	renderMultiDayFields = () => {
		const { status, showMultiDaySelection } = this.state;

		if (!status) {
			return null;
		}

		if (!showMultiDaySelectMap[status]) {
			return null;
		}
		return (
			<Fragment>
				<FormCheckbox
					{...this.getInputProps('showMultiDaySelection', false)}
					label={'Select an end date for this status'}
					showLargeFont={true}
				/>

				{showMultiDaySelection === true && (
					<Fragment>
						<FormDatePicker
							{...this.getInputProps('endDateForStatus')}
							label="End date for status"
							gridProps={{ md: 6 }}
						/>
						<Grid item>
							<strong>NOTE:</strong> This will update all <strong>working days</strong> between the
							start date and the end date you pick. Days off will remain as days off.
						</Grid>
					</Fragment>
				)}
			</Fragment>
		);
	};

	renderNotes = () => {
		const { workDay, classes, userMap } = this.props;
		const { isSavingNote, savingNoteSuccessful } = this.state;
		const { notes = [] } = workDay;
		return (
			<form>
				<Grid container spacing={2} style={{ marginTop: 0, marginBottom: 0 }}>
					<Grid item xs={12}>
						{_.isEmpty(notes) && (
							<div className={classes.noNotes}>
								<i>No notes yet</i>
							</div>
						)}

						{!_.isEmpty(notes) && (
							<div>
								{notes.map((workDayNote) => {
									const { workDayNoteId, creatorUserId, note, dateCreated } = workDayNote;
									const creatorUser = userMap[creatorUserId] || {
										firstName: 'Missing',
										lastName: '',
									};
									const dateFormatted = moment(dateCreated).format('M/D h:mm a');
									return (
										<div className={classes.noteContainer} key={workDayNoteId}>
											<div>
												<strong>
													{creatorUser.firstName} {creatorUser.lastName}{' '}
												</strong>
												said <pre>"{note}"</pre>
											</div>
											<div className={classes.dateNote}>{dateFormatted}</div>
										</div>
									);
								})}
							</div>
						)}
					</Grid>

					<FormTextArea
						{...this.getInputProps('note')}
						label={'New note message...'}
						gridProps={{ xs: 12 }}
					/>
					<Grid item md={12} style={{ display: 'flex', alignItems: 'baseline' }}>
						<Button
							variant="contained"
							color="primary"
							className={classes.addButton}
							onClick={this.submitAddNote}
							disabled={isSavingNote}
						>
							Add note
						</Button>

						<Zoom
							in={isSavingNote}
							style={{ transitionDelay: isSavingNote ? '0ms' : '0ms' }}
							mountOnEnter
							unmountOnExit
						>
							<div className={classes.isSaving}>
								<CircularProgress style={{ verticalAlign: 'middle' }} />
								<span style={{ paddingLeft: 10 }}>Saving...</span>
							</div>
						</Zoom>

						<Zoom
							in={savingNoteSuccessful}
							style={{
								transitionDelay: savingNoteSuccessful ? '250ms' : '0ms',
							}}
						>
							<div className={classes.savingSuccessful}>
								<div className={classes.greenCheckedIcon} />
								<span style={{ paddingLeft: 10 }}>Save Successful.</span>
							</div>
						</Zoom>
					</Grid>
				</Grid>
			</form>
		);
	};

	renderActivity = () => {
		const { workDay, classes, userMap } = this.props;
		const { overrides = [], scheduledData } = workDay;

		return (
			<Grid container spacing={2} style={{ marginTop: 0, marginBottom: 0 }}>
				<Grid item xs={12}>
					{_.isEmpty(overrides) && (
						<div className={classes.noNotes}>
							<i>No activity</i>
						</div>
					)}

					{!_.isEmpty(overrides) && (
						<div>
							{overrides.map((workDayOverride) => {
								const {
									workDayOverrideId,
									creatorUserId,
									dateCreated,
									changeLine,
								} = workDayOverride;

								const creatorUser = userMap[creatorUserId] || {
									firstName: 'Missing',
									lastName: '',
								};
								const dateFormatted = moment(dateCreated).format('M/D h:mm a');

								return (
									<div className={classes.noteContainer} key={workDayOverrideId}>
										<div>
											<strong>
												{creatorUser.firstName} {creatorUser.lastName}{' '}
											</strong>{' '}
											{changeLine}
										</div>
										<div className={classes.dateNote}>{dateFormatted}</div>
									</div>
								);
							})}
						</div>
					)}

					{!!scheduledData && (
						<div>
							<SectionHeader label={'Original Schedule'} />
							<div>Status : {statusMap[scheduledData.status]}</div>
						</div>
					)}
				</Grid>
			</Grid>
		);
	};
}

UpdateWorkDayDialog.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func,
	workDay: PropTypes.object,
	assignedLocationId: PropTypes.number,
	assignedShiftTime: PropTypes.string,
	shiftMap: PropTypes.object,
	openTrucks: PropTypes.array,
	userMap: PropTypes.object,
	onRefreshData: PropTypes.func.isRequired,
	locationIds: PropTypes.array,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	AuthUserContainer,
	//TicketContainer,
])(UpdateWorkDayDialog);
